import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { GLOBAL_SEARCH } from "./constant/global-search.constant";

@Injectable({
  providedIn: "root",
})
export class GlobalSearchService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };
  constructor(private httpClient: HttpClient) {}

  // Register-book service
  public getRegisterBookSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.REGISTER_BOOK_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // schedule-book service
  public getScehduleBookSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.SCHEDULE_BOOK_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // call-log service
  public getCallLogSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.CALL_LOG_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // complain service
  public getComplainSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.COMPLIAN_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // visitor service
  public getVisitorSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.VISITOR_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // visitor service
  public getVisitorEntrySearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.VISITOR_ENTRY_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  //connector service
  public getConnectorSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.CONNECTOR_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  //karyakarta service
  public getKaryakartaSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.KARYAKARTA_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // adhikari service
  public getAdhikariSearchlist(searchData, filters) {
    return this.httpClient.post(
      `${GLOBAL_SEARCH.ADHIKARI_SEARCH_LIST}/${searchData}`,
      filters
    );
  }

  // get json
  public getPageConfig() {
    return this.httpClient.get("/assets/page-configs/list-data.json");
  }
}
